import React from 'react'

export default function PageNotFound() {
  return (
    <div className='d-flex flex-content-center alifn-items-center h-100 w-100'>PageNotFound</div>
  )
}
